<!--
 * @Description: 活码详情页面
 * @Author: mdb
 * @Date: 2023-04-17 16:12:02
 * @LastEditTime: 2023-04-19 15:31:36
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent style="margin-top: 0">
        <DetailForm type="view" :title="t('marketing.市场活动详情')" paramCode="ofbu_source_channel" subdomain="ofbu" />
      </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from './components/DetailForm.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<script lang="ts">
export default { name: 'DcCosOFbuActivityCodeView' }
</script>

<style scoped></style>
